var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrillDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.3333,
    fill: "#1672B9",
    stroke: "#1672B9",
    strokeWidth: 1.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1814 9.51472C19.1814 9.14653 18.8829 8.84805 18.5147 8.84805C18.1465 8.84805 17.8481 9.14653 17.8481 9.51472L18.5147 9.51472L19.1814 9.51472ZM18.5147 9.51472L17.8481 9.51472V26.4853L18.5147 26.4853L19.1814 26.4853V9.51472L18.5147 9.51472Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6143 18.3867L18.5147 26.4863L10.4151 18.3867",
    stroke: "white",
    strokeWidth: 1.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrillDownArrow);
export default __webpack_public_path__ + "static/media/DrillDownArrow.f0c3ed14ac9bc1fb89f857bce71dd33d.svg";
export { ForwardRef as ReactComponent };